import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { BatchPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import {
  resetRetrieveTeacherBatchPaymentList,
  retrieveTeacherBatchPaymentList,
} from "@academy-context/read/application/use-cases/admin/teacher-batch-payment-list-retrieval/retrieve-teacher-batch-payment-list";

const initialState: RetrievalState<BatchPaymentVM[]> = { data: [], fetching: "idle" };

export const retrieveTeacherBatchPaymentListReducer = createReducer<RetrievalState<BatchPaymentVM[]>>(initialState, builder => {
  builder.addCase(retrieveTeacherBatchPaymentList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTeacherBatchPaymentList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTeacherBatchPaymentList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetRetrieveTeacherBatchPaymentList, () => {
    return initialState;
  });
});
